var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"noneData"},[_c('img',{staticClass:"noneIcon",attrs:{"src":_vm.$utils.getPng(
        _vm.$store.state.theme == 'light'
          ? 'icon-gfans-none'
          : 'icon-gfans-none-dark'
      )}}),_c('div',{staticClass:"font1"},[_vm._v("抱歉，未找到该"+_vm._s(_vm.title))]),_c('div',{staticClass:"font2"},[_vm._v("将在 "+_vm._s(_vm.time)+" 秒后自动返回 订阅")]),_c('div',{staticClass:"prohibitbtn primaryBtn",on:{"click":_vm.goDyh}},[_vm._v("返回订阅")])])
}
var staticRenderFns = []

export { render, staticRenderFns }